import React, {useMemo} from 'react';
import {IOrderPaymentModel} from '@src/@interfaces/models/Order/IOrderPaymentModel';

export default function OrderTotalPaymentsPrice(props: {
    payments: IOrderPaymentModel[] | undefined,
    children: (totalPrice: number) => React.ReactNode,
}) {
    const amount = useMemo(() => {
        return Math.floor((props.payments ?? []).reduce<number>((res, item) => {
            if (item.amount) {
                return res + (item.amount * (item.is_charge_back ? -1 : 1));
            }

            return res;
        }, 0));
    }, [props.payments]);

    return <>{props.children(amount)}</>;
}
